import {lessonSparkViewRecordActionTypes as types} from './../constants';

export function requestLessonSparkViewRecords() {
  return {type: types.LESSON_SPARK_USER_VIEW_LOAD_REQUEST};
}

export function loadLessonSparkViewRecordsSuccess(data) {
  return {
    type: types.LESSON_SPARK_USER_VIEW_LOAD_SUCCESS,
    lessonSparkViewRecords: data,
    receivedAt: Date.now()
  };
}

export function loadLessonSparkViewRecordsFailure() {
  return {
    type: types.LESSON_SPARK_USER_VIEW_LOAD_FAILURE,
    lessonSparkViewRecords: null,
    receivedAt: Date.now()
  };
}
